module.exports = __webpack_public_path__ + "static/media/memberspic.27081367.png";